import { supabase } from "@/integrations/supabase/client";

// Define types for user preferences
export interface UserPreferences {
  id: string;
  user_id: string;
  base_currency: string;
  base_official_divide: boolean;
  second_currency: string;
  second_official_divide: boolean;
  third_currency: string;
  third_official_divide: boolean;
  created_at: string;
  updated_at: string;
}

// Available currencies for selection
export const AVAILABLE_CURRENCIES = ["USD", "EUR", "GBP", "JPY", "RUB", "KWD", "SAR", "CHF", "XAU", "BTC", "TRY"];

// User preferences API
export const userPreferencesAPI = {
  // Get user preferences
  async getUserPreferences() {
    try {
      const { data: { session } } = await supabase.auth.getSession();
      
      if (!session) {
        throw new Error('Authentication required');
      }

      const { data, error } = await supabase
        .from('user_preferences')
        .select('*')
        .single();
      
      if (error) {
        // If no preferences found, create default preferences
        if (error.code === 'PGRST116') {
          return this.createDefaultPreferences();
        }
        throw error;
      }
      
      return { data, error: null };
    } catch (error) {
      
      return { data: null, error };
    }
  },

  // Create default preferences for a user
  async createDefaultPreferences() {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      
      if (!user) {
        throw new Error('Authentication required');
      }

      const defaultPreferences = {
        user_id: user.id,
        base_currency: 'TRY',
        base_official_divide: false,
        second_currency: 'USD',
        second_official_divide: false,
        third_currency: 'EUR',
        third_official_divide: false,
      };

      const { data, error } = await supabase
        .from('user_preferences')
        .insert(defaultPreferences)
        .select()
        .single();
        
      if (error) {
        throw error;
      }
      
      return { data, error: null };
    } catch (error) {
      
      return { data: null, error };
    }
  },

  // Update user preferences
  async updateUserPreferences(preferences: Partial<UserPreferences>) {
    try {
      const { data: { session } } = await supabase.auth.getSession();
      
      if (!session) {
        throw new Error('Authentication required');
      }

      // Make sure we're only updating allowed fields
      const updateData = {
        base_currency: preferences.base_currency,
        base_official_divide: preferences.base_official_divide,
        second_currency: preferences.second_currency,
        second_official_divide: preferences.second_official_divide,
        third_currency: preferences.third_currency,
        third_official_divide: preferences.third_official_divide,
      };

      const { data, error } = await supabase
        .from('user_preferences')
        .update(updateData)
        .eq('user_id', session.user.id)
        .select()
        .single();
        
      if (error) {
        throw error;
      }
      
      return { data, error: null };
    } catch (error) {
      
      return { data: null, error };
    }
  }
}; 